// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2UfWO","left":"styles_left__1k__I","desktopActions":"styles_desktopActions__3YIY3","title":"styles_title__XQc5H"};